import { Controller } from '@organisms';
import { Col, Flex, Row, Typography } from 'antd';
import { FC } from 'react';
import { Control } from 'react-hook-form';

import { CurrencyController } from 'src/app/framework/organisms/Controllers/CurrencyController.organism';

interface FormPromotionalOfferProps {
  control: Control<any>;
  isDisabled: boolean;
}

export const FormPromotionalOffer: FC<FormPromotionalOfferProps> = ({
  control,
  isDisabled,
}: FormPromotionalOfferProps) => {
  return (
    <Flex vertical style={{ width: '100%' }}>
      <Row
        style={{
          gap: 24,
        }}
      >
        <Col style={{ flex: 1 }}>
          <CurrencyController
            control={control}
            name='promotionalOffer.promotionalAmount'
            defaultValue={''}
            placeholder='0,00'
            label='Valor'
            required
            allowZero
            disabled={isDisabled}
            tooltip={{
              title: () => (
                <Typography.Text>A partir de R$ 0,00</Typography.Text>
              ),
            }}
          />
        </Col>
        <Col style={{ flex: 1 }}>
          <Controller
            control={control}
            name='promotionalOffer.qtdPromotionalDays'
            label='Quantidade de dias'
            type='number'
            required
            disabled={isDisabled}
          />
        </Col>
      </Row>
    </Flex>
  );
};
